import { get } from '@/app/core/request';
import AccommodationProjection from '@/types/projections/AccommodationProjection';
import { AccommodationRoutes } from '@/app/api-routes';

class AccommodationApi {
  async searchAccommodations(communeId: number, query: string): Promise<AccommodationProjection[]> {
    return get<AccommodationProjection[]>(AccommodationRoutes.accommodationSearch(String(communeId), query));
  }

  async fetchAccommodation(communeId: number, uid: number): Promise<AccommodationProjection> {
    return get<AccommodationProjection>(AccommodationRoutes.accommodationFetch(String(communeId), String(uid)));
  }
}

export default new AccommodationApi();
